import {lightTheme} from '@app/styles';

export const getDefaultFeatureStyle = (color = 'primary') => [
  {
    'stroke-color': `${lightTheme.palette[color].main}`,
    'stroke-width': 2,
    'fill-color': `${lightTheme.palette[color].light}4D`,
  },
];

export const getSelectedStyle = (color = 'primary') => [
  {
    'stroke-color': '#3d3d3d',
    'stroke-width': 4,
    'fill-color': `${lightTheme.palette[color].light}8C`,
  },
  {
    'stroke-color': `${lightTheme.palette[color].main}`,
    'stroke-width': 2,
  },
];
